<template>
  <div class="max-w-screen-xl xl:px-8 p-4 mx-auto mt-8">
    <div class="grid grid-cols-12 gap-3">
      <div
        v-for="widget in widgets"
        @click="openPreview(widget)"
        class="2xl:col-span-3 xl:col-span-3 lg:col-span-4 xs:col-span-6 col-span-12 hover:bg-gradient-to-r hover:from-green-500 hover:via-lime-500 hover:to-yellow-500 rounded-2xl hover:drop-shadow-lg p-2"
      >
        <div
          class="relative block p-4 shadow-xl rounded-xl bg-white cursor-pointer h-full"
        >
          <span
            v-if="checkTag(widget.type_explore.id) == 'hot'"
            class="absolute -right-2 -top-4 rounded-full px-2 py-1 bg-red-500 text-white font-medium text-xs"
          >
            Hot
          </span>
          <span
            v-if="checkTag(widget.type_explore.id) == 'new'"
            class="absolute -right-2 -top-4 rounded-full px-2 py-0.5 bg-success text-white font-medium text-xs"
          >
            New
          </span>
          <div class="flex items-center">
            <h2
              class="text-lg font-matter font-bold text-gray-900 line-clamp-1"
            >
              {{ widget.type_explore.title }}
            </h2>
            <img
              :src="
                'https://app.qrgateway.com/explores/' + widget.type_explore.icon
              "
              class="w-12 ml-auto"
              :alt="widget.type_explore.title"
            />
          </div>
          <p class="mt-4 sr-only">{{ widget.type_explore.description }}</p>
        </div>
      </div>
      <div
        @click="openLinkBuilder"
        class="2xl:col-span-3 xl:col-span-3 lg:col-span-4 xs:col-span-6 col-span-12 hover:bg-gradient-to-r hover:from-green-500 hover:via-lime-500 hover:to-yellow-500 rounded-2xl hover:drop-shadow-lg p-2"
      >
        <div
          class="relative block p-4 shadow-xl rounded-xl bg-white cursor-pointer h-full"
        >
          <div class="flex items-center">
            <h2
              class="text-lg font-matter font-bold text-gray-900 line-clamp-1"
            >
              Page Builder
            </h2>
            <img
              src="/icons/builder.svg"
              class="w-12 ml-auto"
              :alt="'page-builder'"
            />
          </div>
        </div>
      </div>
    </div>
    <template v-if="widget_select">
      <PreviewWidgetDialog :widget="widget_select" />
    </template>
  </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from "pinia";
import { useQrCreateStore } from "~~/stores/qrcreate";
import PreviewWidgetDialog from "../partials/PreviewWidgetDialog.vue";

interface ExploreType {
  type_explore: {
    id: number;
    title: string;
    description: string;
    group_explore_id: number;
    icon: string;
    status: number;
    full_widget: number;
  };
  name: string;
  image: string;
  uuid: string;
  slug: string;
}
const res = await useAsyncData(async () => {
  const res = [
    {
        "type_explore": {
            "title": "Facebook",
            "description": "Add link or Facebook like button to your qr code",
            "group_explore_id": 1,
            "icon": "facebook.svg"
        },
        "name": "Facebook Sample",
        "image": "samples/facebook.png",
        "uuid": "6dc177f5-cebd-45c1-8f58-1a23fcab2cc9",
        "slug": "facebook-sample"
    },
    {
        "type_explore": {
            "title": "WhatsApp Chat",
            "description": "Give users an opportunity to contact you on WhatsApp straight from your qrcode",
            "group_explore_id": 6,
            "icon": "whatsapp.svg"
        },
        "name": "WhatsApp Chat Sample",
        "image": "samples/whatsapp.png",
        "uuid": "62db68eb-27bc-4926-a72b-26f0f2c5e777",
        "slug": "whatsapp-sample"
    },
    {
        "type_explore": {
            "title": "Instagram",
            "description": "Share your moments and collections",
            "group_explore_id": 1,
            "icon": "instagram.svg"
        },
        "name": "Instagram Sample",
        "image": "samples/instagram.png",
        "uuid": "114c1f8a-283d-4235-96f3-fb78846b1c65",
        "slug": "instagram-sample"
    },
    {
        "type_explore": {
            "title": "Restaurant Menu",
            "description": "Present your dishes and drinks on your qrcode to attract more guests",
            "group_explore_id": 5,
            "icon": "menu_restaurant.svg"
        },
        "name": "Restaurant Menu Sample",
        "image": "samples/menu.png",
        "uuid": "f58ff958-8ebe-4a2f-83bf-e4e6713ca83f",
        "slug": "menu-sample"
    },
    {
        "type_explore": {
            "title": "Contact Form",
            "description": "Collect visitor contact info and messages",
            "group_explore_id": 5,
            "icon": "form.svg"
        },
        "name": "Contact Form Sample",
        "image": "samples/contact.png",
        "uuid": "1ac79a45-7a4a-4857-b355-fcff5ba2aa4c",
        "slug": "contact-sample"
    },
    {
        "type_explore": {
            "title": "YouTube",
            "description": "Share YouTube videos on your qr code",
            "group_explore_id": 1,
            "icon": "youtube.svg"
        },
        "name": "YouTube Sample",
        "image": "samples/youtube.png",
        "uuid": "9cfa55f4-f52e-4eb3-9fbb-45cbfb8d466a",
        "slug": "youtube-sample"
    },
    {
        "type_explore": {
            "title": "FAQ",
            "description": "Demonstrate the answers to the most common questions on your qrcode",
            "group_explore_id": 2,
            "icon": "faq.svg"
        },
        "name": "FAQ Sample",
        "image": "samples/faq.png",
        "uuid": "18018904-268e-4ab5-907d-ea16b47c2ec5",
        "slug": "faq-sample"
    },
    {
        "type_explore": {
            "title": "PayPal",
            "description": "Get paid and donation with PayPal",
            "group_explore_id": 3,
            "icon": "paypal.svg"
        },
        "name": "PayPal Sample",
        "image": "samples/paypal.png",
        "uuid": "0e984e2d-c265-4756-95d5-e93a9c25a6cc",
        "slug": "paypal-sample"
    },
    {
        "type_explore": {
            "title": "Twitter",
            "description": "Showcase your tweets and Twitter feed",
            "group_explore_id": 1,
            "icon": "twitter.svg"
        },
        "name": "Twitter Sample",
        "image": "samples/twitter.png",
        "uuid": "78ce5d5a-ab2c-40f4-b425-f50e95f9ff34",
        "slug": "twitter-sample"
    },
    {
        "type_explore": {
            "title": "Spotify",
            "description": "Share your latest or favorite music",
            "group_explore_id": 1,
            "icon": "spotify.svg"
        },
        "name": "Spotify Sample",
        "image": "samples/spotify.png",
        "uuid": "780f05bd-ab1e-4008-ab7b-2a47dfbfc23e",
        "slug": "spotify-sample"
    },
    {
        "type_explore": {
            "title": "TikTok",
            "description": "Grow your TikTok following",
            "group_explore_id": 1,
            "icon": "tiktok.svg"
        },
        "name": "TikTok Sample",
        "image": "samples/tiktok.png",
        "uuid": "ac36c238-46b8-4fda-93f3-1166acd61198",
        "slug": "tiktok-sample"
    },
    {
        "type_explore": {
            "title": "NFT Gallery",
            "description": "Showcase NFTs you own on your qr code",
            "group_explore_id": 2,
            "icon": "nft.svg"
        },
        "name": "NFT Gallery Sample",
        "image": "samples/nft.png",
        "uuid": "33529105-a1fb-4686-a18c-5f53569ec126",
        "slug": "nft-sample"
    },
    {
        "type_explore": {
            "title": "Video",
            "description": "Upload videos and play them right",
            "group_explore_id": 2,
            "icon": "video.svg"
        },
        "name": "Video Sample",
        "image": "samples/video.png",
        "uuid": "e471a1ef-ce82-438a-8ca0-702fe6af3606",
        "slug": "video-sample"
    },
    {
        "type_explore": {
            "title": "Music",
            "description": "Upload music and get more streams",
            "group_explore_id": 2,
            "icon": "music.svg"
        },
        "name": "Music Sample",
        "image": "samples/music.png",
        "uuid": "9a8e9c50-3d7f-421a-b999-adb3cfefed6b",
        "slug": "music-sample"
    },
    {
        "type_explore": {
            "title": "Shopify",
            "description": "Display your products to boost sales",
            "group_explore_id": 4,
            "icon": "shopify.svg"
        },
        "name": "Shopify Sample",
        "image": "samples/shopify.png",
        "uuid": "df54b9ff-0a05-45c4-8841-442f6454e9ec",
        "slug": "shopify-sample"
    },
    {
        "type_explore": {
            "title": "Facebook Review",
            "description": "Display reviews from your Facebook page on your site",
            "group_explore_id": 5,
            "icon": "facebook_review.svg"
        },
        "name": "Facebook Review Sample",
        "image": "samples/fb-review.png",
        "uuid": "03ca35db-2825-4a3c-a76f-efc73eec379e",
        "slug": "fb-review-sample"
    },
    {
        "type_explore": {
            "title": "Amazon Review",
            "description": "Share reviews about your products or store from Amazon on your site",
            "group_explore_id": 5,
            "icon": "amazon_review.svg"
        },
        "name": "Amazon Review Sample",
        "image": "samples/amazon-review.png",
        "uuid": "a30985f5-f186-49ce-8929-9747b2537e3d",
        "slug": "amazon-review-sample"
    },
    {
        "type_explore": {
            "title": "Viber Chat",
            "description": "Let users message you on Viber directly from your website",
            "group_explore_id": 6,
            "icon": "viber_chat.svg"
        },
        "name": "Viber Chat Sample",
        "image": "samples/viber.png",
        "uuid": "12e94554-0be8-45dd-9603-c85b0205f680",
        "slug": "viber-sample"
    },
    {
        "type_explore": {
            "title": "Line Chat",
            "description": "Let users reach you out on Line right from your website",
            "group_explore_id": 6,
            "icon": "line_chat.svg"
        },
        "name": "Line Chat Sample",
        "image": "samples/line.png",
        "uuid": "b43fc828-1145-4507-b494-481ba5f6d8f4",
        "slug": "line-sample"
    },
    {
        "type_explore": {
            "title": "Facebook Chat",
            "description": "Allow users to contact you on Facebook Messenger from your qrcode",
            "group_explore_id": 6,
            "icon": "facebook_chat.svg"
        },
        "name": "Facebook Chat Sample",
        "image": "samples/fb-chat.png",
        "uuid": "de89a9ce-e08c-49f3-a288-421d8d7d2a40",
        "slug": "fb-chat-sample"
    },
    {
        "type_explore": {
            "title": "Instagram Chat",
            "description": "Allow users to contact you on Instagram from your website",
            "group_explore_id": 6,
            "icon": "instagram_chat.svg"
        },
        "name": "Instagram Chat Sample",
        "image": "samples/ig-chat.png",
        "uuid": "6cd69e4a-6ba6-456e-8431-4e13a84ba1ea",
        "slug": "ig-chat-sample"
    },
    {
        "type_explore": {
            "title": "Click to Call",
            "description": "Provide users with the fastest way to call you directly from your qrcode",
            "group_explore_id": 6,
            "icon": "click_call.svg"
        },
        "name": "Click to Call Sample",
        "image": "samples/call.png",
        "uuid": "926f1d86-5a85-4ffe-9f3a-0df9478e319f",
        "slug": "call-sample"
    },
    {
        "type_explore": {
            "title": "Pinterest",
            "description": "Showcase Pins, boards and more",
            "group_explore_id": 1,
            "icon": "pinterest.svg"
        },
        "name": "Pinterest Sample",
        "image": "samples/pinterest.png",
        "uuid": "e78aba17-884a-4410-aaaa-1d96b4b7228a",
        "slug": "pinterest-sample"
    },
    {
        "type_explore": {
            "title": "Vimeo",
            "description": "Add Vimeo videos to your qr code",
            "group_explore_id": 1,
            "icon": "vimeo.svg"
        },
        "name": "Vimeo Sample",
        "image": "samples/vimeo.png",
        "uuid": "beed2b32-862c-47fe-bf6d-935c4812f59b",
        "slug": "vimeo-sample"
    },
    {
        "type_explore": {
            "title": "Twitch",
            "description": "Get more stream viewers and engagement",
            "group_explore_id": 1,
            "icon": "twitch.svg"
        },
        "name": "Twitch Sample",
        "image": "samples/twitch.png",
        "uuid": "921d56d2-0719-4293-9d96-92d3be06a515",
        "slug": "twitch-sample"
    },
    {
        "type_explore": {
            "title": "SoundCloud",
            "description": "Get your music heard on SoundCloud",
            "group_explore_id": 1,
            "icon": "soundcloud.svg"
        },
        "name": "SoundCloud Sample",
        "image": "samples/soundcloud.png",
        "uuid": "08f17e2e-97b7-4c48-b72c-21a67c15e7fb",
        "slug": "soundcloud-sample"
    },
    {
        "type_explore": {
            "title": "Apple Music",
            "description": "Share songs in itunes library",
            "group_explore_id": 1,
            "icon": "apple-music.svg"
        },
        "name": "Apple Music Sample",
        "image": "samples/apple-music.png",
        "uuid": "b2771560-4311-4c8b-ab2e-c126964696c5",
        "slug": "apple-music-sample"
    },
    {
        "type_explore": {
            "title": "Podcasts",
            "description": "Get more podcast listeners and subscribers",
            "group_explore_id": 2,
            "icon": "podcast.svg"
        },
        "name": "Podcast Sample",
        "image": "samples/podcast.png",
        "uuid": "08722325-1dee-40a7-8e7d-1b3f88767b92",
        "slug": "podcast-sample"
    },
    {
        "type_explore": {
            "title": "Mobile App",
            "description": "Promote a mobile app & get more downloads",
            "group_explore_id": 2,
            "icon": "mobile-app.svg"
        },
        "name": "Mobile App Sample",
        "image": "samples/app.png",
        "uuid": "f57e0159-2df1-4654-8bb8-9c9928a8583c",
        "slug": "app-sample"
    },
    {
        "type_explore": {
            "title": "Stripe",
            "description": "Get paid and donation with Stripe",
            "group_explore_id": 3,
            "icon": "stripe.svg"
        },
        "name": "Stripe Sample",
        "image": "samples/stripe.png",
        "uuid": "b2945b0b-1769-454c-af50-dca9d96e20de",
        "slug": "stripe-sample"
    },
    {
        "type_explore": {
            "title": "WooCommerce",
            "description": "Showcase your products to order conversion rates",
            "group_explore_id": 4,
            "icon": "woocommerce.svg"
        },
        "name": "WooCommerce Sample",
        "image": "samples/woo.png",
        "uuid": "61f6c992-4563-411d-bd63-4769e7c63067",
        "slug": "woo-sample"
    },
    {
        "type_explore": {
            "title": "Magento 2",
            "description": "An advanced and effective way of marketing products",
            "group_explore_id": 4,
            "icon": "magento.svg"
        },
        "name": "Magento Sample",
        "image": "samples/magento.png",
        "uuid": "8d3ec3f3-8044-4b79-af51-a2bf987d5cee",
        "slug": "magento-sample"
    },
    {
        "type_explore": {
            "title": "BigCommerce",
            "description": "Maximize cost savings on advertising and marketing",
            "group_explore_id": 4,
            "icon": "bigcommerce.svg"
        },
        "name": "BigCommerce Sample",
        "image": "samples/bigcommerce.png",
        "uuid": "e8fa0813-533d-40f2-bc60-2ac84d5b9bfe",
        "slug": "bigcommerce-sample"
    }
]


  return res as ExploreType[];
});
const widgets = res.data.value as ExploreType[];
const checkTag = (id: number) => {
  const news = [36, 37, 38, 39, 40, 41, 42, 43, 44];
  const hots = [15, 29, 17];
  if (news.includes(id)) {
    return "new";
  }
  if (hots.includes(id)) {
    return "hot";
  }
  return "";
};
const { preview_widget_modal } = storeToRefs(useQrCreateStore());
const widget_select = ref<ExploreType | null>(null);
const { redirectUrl } = useUtils();
const openPreview = (widget: ExploreType) => {
  if (typeof window !== "undefined") {
    const screen = window.innerWidth;
    if (screen < 768) {
      const url =
        "https://app.qrgateway.com/sign-up?createSample=" + widget.uuid;
      redirectUrl(url);
      return;
    }
  }
  widget_select.value = widget;
  if (widget_select.value) {
    preview_widget_modal.value = true;
  }
};

const openLinkBuilder = () => {
  redirectUrl("https://app.qrgateway.com/page-builder");
};
</script>
